export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01-5.2042515b.svg";